module.exports = __webpack_public_path__ + "img/gift-store-icon.4fa8905f.svg";